import { render, staticRenderFns } from "./VariationsValueAndCountChart.vue?vue&type=template&id=6c857d1f&scoped=true"
import script from "./VariationsValueAndCountChart.vue?vue&type=script&lang=js"
export * from "./VariationsValueAndCountChart.vue?vue&type=script&lang=js"
import style0 from "./VariationsValueAndCountChart.vue?vue&type=style&index=0&id=6c857d1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c857d1f",
  null
  
)

export default component.exports